<template>
  <div class="content">
    <div class="col-md-8 ml-auto mr-auto">
      <h2 class="text-center">{{ $t('auditLogs.all.title') }}</h2>
      <p class="text-center">
        {{ $t('auditLogs.all.description') }}
      </p>
    </div>
    <div class="row mt-5">
      <div class="col-12">
        <card card-body-classes="table-full-width">
          <h4 slot="header" class="card-title">{{ $t('auditLogs.all.auditLogs') }}</h4>
          <audit-log-table :account-audit-logs="false"/>
        </card>
      </div>
    </div>
  </div
  >
</template>
<script>
import AuditLogTable from "@/components/AuditLog/AuditLogTable";

export default {
  name: 'audit-logs',
  components: {AuditLogTable},
};
</script>
